module.exports = __webpack_public_path__ + "img/my-filters.7a8a4725.png";